const KEY_STRING = 'BRXP2hS718VggV8o';
const IV_STRING = 'tmBBSvHKibnirIrZ';

const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
const iv = textEncoder.encode(IV_STRING);

const importKey = () =>
  crypto.subtle.importKey(
    'raw',
    textEncoder.encode(KEY_STRING),
    { name: 'AES-CBC' },
    false,
    ['encrypt', 'decrypt']
  );

const bytesToBase64 = (bytes: ArrayBuffer) =>
  btoa(String.fromCharCode(...new Uint8Array(bytes)));

const base64ToBytes = (base64: string) =>
  Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));

const encrypt = async (password: string) => {
  const key = await importKey();
  const ciphertext = await crypto.subtle.encrypt(
    { name: 'AES-CBC', iv },
    key,
    textEncoder.encode(password)
  );
  return bytesToBase64(ciphertext);
};

const decrypt = async (encrypted_password: string) => {
  const key = await importKey();
  const plaintext = await crypto.subtle.decrypt(
    { name: 'AES-CBC', iv },
    key,
    base64ToBytes(encrypted_password)
  );
  return textDecoder.decode(plaintext);
};

const EncryptData = {
  encrypt,
  decrypt
};

export default EncryptData;
